export default {
    getDataTableOptions: state => state.dataTableOptions,
    getRowActions: state => state.rowActions,
}
